import React, { useState, useEffect, createRef } from "react";
// import "./App.css";
import ReferFriendSection from "./components/ReferFriendSection";
import { connect } from "react-redux";
import {
  setCustomerId,
  setParentLocation,
  setShopDomain,
} from "./actions/appstateActions";
import { fetchMerchant } from "./actions/merchantActions";
import {
  fetchCustomer,
  fetchCustomerGiftcards,
} from "./actions/customerActions";
import { defaultCss } from "./helpers/defaultCss";
import JoinNowSection from "./components/JoinNowSection";
import WaysToEarnSection from "./components/WaysToEarnSection";
import WaysToRedeemSection from "./components/WaysToRedeemSection";
import RewardsSection from "./components/RewardsSection";
import VipTierSection from "./components/VipTierSection";
import MembershipProgramSection from "./components/MembershipProgramSection";
import LimitedTimeOfferProgramSection from "./components/LimitedTimeOfferProgramSection";
import AccountSection from "./components/AccountSection";

function App({
  appStateData,
  setCustomerId,
  setShopDomain,
  fetchMerchant,
  merchantData,
  fetchCustomer,
  fetchCustomerGiftcards,
  customerData,
  setParentLocation,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [cssCode, setCssCode] = useState(false);

  const { customerId, shopDomain } = appStateData;
  const { customer, giftcards } = customerData;
  const { merchant } = merchantData;

  const referFriendRef = createRef(null);
  const waysToRedeemRef = createRef(null);
  const waysToEarnRef = createRef(null);
  const rewardsRef = createRef(null);

  useEffect(() => {
    let params = new URLSearchParams(window.location.search);
    // console.log(params.toString());
    console.log(params.get("shopDomain"));
    console.log(params.get("customerId"));
    console.log(params.get("parentLocation"));
    setShopDomain(params.get("shopDomain"));
    params.get("customerId") === "undefined"
      ? setCustomerId(undefined)
      : setCustomerId(parseInt(params.get("customerId")));
    setParentLocation(params.get("parentLocation"));
  }, []);

  useEffect(() => {
    if (shopDomain) {
      console.log("s_");
      // console.log("appStateData", appStateData);
      fetchMerchant(shopDomain);
    }
  }, [shopDomain]);

  useEffect(() => {
    (async () => {
      if (
        customerId !== NaN &&
        customerId !== undefined &&
        typeof customerId !== "string" &&
        Object.keys(customer ?? {}).length === 0
      ) {
        setIsLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        console.timeEnd("c_");
        await fetchCustomer(customerId, shopDomain);
        setIsLoading(false);
      }
    })();
  }, [customerId, customer]);

  useEffect(() => {
    (async () => {
      if (
        customerId !== NaN &&
        customerId !== undefined &&
        typeof customerId !== "string"
      ) {
        fetchCustomerGiftcards(customerId, shopDomain);
      }
    })();
  }, [customerId]);

  useEffect(() => {
    // console.log(document.body.scrollHeight);
    setTimeout(() => {
      window.parent.frames.postMessage(
        { height: document.body.scrollHeight },
        "*"
      );
    }, 1500);
  }, [document.body.scrollHeight]);

  useEffect(() => {
    merchant?.rewardsPageTheme?.cssCode &&
      setCssCode(merchant?.rewardsPageTheme?.cssCode);
  }, [merchant]);

  useEffect(() => {
    //adding css
    let SA_style = document.createElement("style");

    if (cssCode) {
      setIsLoading(true);
      SA_style.textContent = cssCode;
      document.body.appendChild(SA_style);
      setIsLoading(false);
    } else {
      setIsLoading(true);
      SA_style.textContent = defaultCss;
      document.body.appendChild(SA_style);
      setIsLoading(false);
    }
  }, [cssCode]);

  if (isLoading) {
    return (
      <div className="rewards-page-loading-wrapper">
        <div className="rewards-page-loading">
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }

  return (
    <div className="rewards-page-wrapper">
      {!customerId && <JoinNowSection />}
      {customerId && (
        <AccountSection
          referFriendRef={referFriendRef}
          waysToRedeemRef={waysToRedeemRef}
          waysToEarnRef={waysToEarnRef}
        />
      )}
      {customerId && <RewardsSection rewardsRef={rewardsRef} />}
      <WaysToEarnSection waysToEarnRef={waysToEarnRef} />
      {merchant?.isPointsActive && (
        <WaysToRedeemSection
          waysToRedeemRef={waysToRedeemRef}
          rewardsRef={rewardsRef}
        />
      )}
      {merchant?.isVipTiersActive && <VipTierSection />}
      {merchant?.isMembershipProgramActive && <MembershipProgramSection />}
      <LimitedTimeOfferProgramSection />

      {merchant?.isReferralsActive && (
        <ReferFriendSection referFriendRef={referFriendRef} />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  appStateData: state.AppstateReducer,
  merchantData: state.MerchantReducer,
  customerData: state.CustomerReducer,
});

const mapDispatchToProps = (dispatch) => ({
  setShopDomain: (shopDomain) => dispatch(setShopDomain(shopDomain)),
  fetchMerchant: (shopDomain) => dispatch(fetchMerchant(shopDomain)),
  setCustomerId: (id) => dispatch(setCustomerId(id)),
  fetchCustomer: (customerId, shopDomain) =>
    dispatch(fetchCustomer(customerId, shopDomain)),
  fetchCustomerGiftcards: (customerId, shopDomain) =>
    dispatch(fetchCustomerGiftcards(customerId, shopDomain)),
  setParentLocation: (location) => dispatch(setParentLocation(location)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
